import React from "react";
import { Container, SectionLabel } from "@/components/shared";
import Seo from "@/components/Seo";

export function LegalShell({ title, updated, intro, children }) {
  return (
    <div data-testid="legal-page">
      <Seo title={title} description={`${title} — FightFund, a U.S.-only crowdfunding platform.`} />
      <section className="border-b border-ff-border bg-ff-blue text-white">
        <Container className="py-14 lg:py-16">
          <SectionLabel><span className="text-white/60">Legal</span></SectionLabel>
          <h1 className="mt-3 font-heading text-4xl font-extrabold tracking-tight sm:text-5xl">{title}</h1>
          {updated && <p className="mt-4 text-sm text-white/60">Last updated: {updated}</p>}
          {intro && <p className="mt-4 max-w-2xl text-white/70">{intro}</p>}
        </Container>
      </section>
      <section className="bg-white">
        <Container className="py-12 lg:py-16">
          <div className="mx-auto max-w-3xl space-y-8">{children}</div>
        </Container>
      </section>
    </div>
  );
}

export function LegalSection({ n, title, children }) {
  return (
    <div>
      <h2 className="font-heading text-xl font-bold text-ff-blue">{n ? `${n}. ` : ""}{title}</h2>
      <div className="mt-2 space-y-3 text-sm leading-relaxed text-ff-dark">{children}</div>
    </div>
  );
}
